import { render, staticRenderFns } from "./EmailNotificationSettings.vue?vue&type=template&id=5821f838&scoped=true&"
import script from "./EmailNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationSettings.vue?vue&type=style&index=0&id=5821f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821f838",
  null
  
)

export default component.exports